import React, { ReactNode } from 'react';
import { Page } from 'vetrf-ui';
import { getBreadcrumbs } from './consts';

type RegistryWrapperProps = {
  registryName: string;
  subRegistryName?: string;
  header?: string;
  subHeader?: string;
  children: ReactNode;
};

export const RegistryWrapper = ({
  registryName,
  subRegistryName,
  subHeader,
  header,
  children,
}: RegistryWrapperProps) => (
  <Page
    title={registryName}
    breadcrumbs={getBreadcrumbs(registryName, subRegistryName)}
    header={header}
    subHeader={subHeader}
  >
    {children}
  </Page>
);
